module.exports = __webpack_public_path__ + "r-v3/img/ml_12_00_over.9ae4100e.jpg";